import { Link, useLocation } from 'react-router-dom';

import { useGetPointsOfSalesQuery } from '~entities/pos';

import cn from 'classnames';

import { SkyroLogo } from './skyro-logo';

import { Container } from '../layout';

type NavLinkProps = {
  to: string;
  name: string;
  isActive: boolean;
};

const NavLink = ({ to, name, isActive }: NavLinkProps) => {
  return (
    <Link
      to={to}
      className={cn('px-5 text-[17px] no-underline', {
        'font-medium text-[#191c1e]': !isActive,
        'font-semibold text-skyro-blue': isActive,
      })}
    >
      {name}
    </Link>
  );
};
export const Header = () => {
  const { pathname } = useLocation();
  const { data: posList, isLoading: posLoading } = useGetPointsOfSalesQuery();
  const hasOnlineStores = posList?.find((pos) => pos.type === 'ONLINE');
  return (
    <header
      className={`
        flex h-20 items-center border-x-0 border-b border-t-0 border-solid
        border-[#eaecee] bg-white
      `}
    >
      <Container>
        <nav className="flex items-center justify-between gap-2">
          <Link to="/">
            <SkyroLogo />
          </Link>
          <ul className="flex list-none items-center">
            <li>
              <NavLink
                to="/"
                name="Dashboard"
                isActive={pathname === '/dashboard'}
              />
            </li>
            <li>
              <NavLink
                to={
                  pathname.startsWith('/transactions')
                    ? pathname
                    : '/transactions'
                }
                name="Transactions"
                isActive={pathname.startsWith('/transactions')}
              />
            </li>
            {(posLoading || hasOnlineStores) && (
              <li>
                <NavLink
                  to="/orders"
                  name="Orders"
                  isActive={pathname === '/orders'}
                />
              </li>
            )}
          </ul>
        </nav>
      </Container>
    </header>
  );
};
